import React from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  VStack,
  HStack
} from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import {BiMenuAltLeft, BiOutline} from "react-icons/bi"


const Header = () => {
  const {isOpen,onClose,onOpen}=useDisclosure();
  return (
    <>
    <Button 
    pos={"fixed"}
     top={4} 
     left={4} 
     h={10} 
     colorScheme='purple'
      p={"0"}
       w={'10'}
        borderRadius={"full"}
        onClick={onOpen}
        zIndex={"overlay"}
        >
      <BiMenuAltLeft size={20}/>
    </Button>
    <Drawer isOpen={isOpen} placement='left' onClose={onClose}>
      <DrawerOverlay/>
      <DrawerContent>
      <DrawerCloseButton/> 
      <DrawerHeader>VIDEO HUB</DrawerHeader>
      <DrawerBody >
        <VStack alignItems={"stretch"}>
          <Button  onClick={onClose} variant={"ghost"} colorScheme='purple' as={Link} to={"/"} justifyContent={"flex-start"}>
            Home
          </Button>
          <Button onClick={onClose} variant={"ghost"} colorScheme='purple' justifyContent={"flex-start"} as={Link} to={"/videos"} > 
            Videos
          </Button>
          <Button onClick={onClose} variant={"ghost"} colorScheme='purple'  justifyContent={"flex-start"} as={Link} to={"/videos?category=free"}>
            Free Videos
          </Button>
          <Button onClick={onClose} variant={"ghost"} colorScheme='purple' justifyContent={"flex-start"} as={Link} to={"/upload"}>
            Upload
          </Button>
        </VStack>
        <HStack pos={"absolute"} left={0} bottom={"10"} justifyContent={"space-evenly"} w={"full"}>
          <Button  onClick={onClose} colorScheme='purple'><Link to={'/login'}>Login</Link></Button>
          <Button  onClick={onClose} colorScheme='purple' variant={"outline"}><Link to={'/signup'}>Sign Up</Link></Button>
        </HStack>
      </DrawerBody>
      </DrawerContent>
    </Drawer>
    </>

  )
}

export default Header;